var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"access-denied"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('h2',[_vm._v("You do not have access to this application.")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }